export const trList = {
  data: {
    personByEmailAddress: {
      emailAddress: 'ashrivastava@atlassian.com',
      transactionAccounts: {
        totalCount: 57,
        pageInfo: {
          hasNextPage: true,
          endCursor: 'WyJjOTJiMzE0NS0yZGFkLTQxZjEtODMwNC05MTU2MzFhNDE5NGEiXQ==',
          __typename: 'PageInfo',
        },
        nodes: [
          {
            displayName: null,
            id: 'fe29b550-b324-4a8f-86ef-f6cf33430b0c',
            transactionAccountNumber: 'AC-3WN5-6FT3-JJ4G',
            __typename: 'TransactionAccount',
          },
          {
            displayName: null,
            id: 'f287dccc-bafa-46d6-973d-84ee0207a928',
            transactionAccountNumber: 'AC-3WN9-KR39-PN3C',
            __typename: 'TransactionAccount',
          },
          {
            displayName: null,
            id: 'f06c3036-0e26-45a5-a809-1ea98a1e6f5b',
            transactionAccountNumber: 'AC-3WMD-45QB-NPHG',
            __typename: 'TransactionAccount',
          },
          {
            displayName: 'Test Company1021',
            id: 'edf158f5-358a-43fe-b78a-0cf300f70c1d',
            transactionAccountNumber: 'AC-3X7B-HV5W-FY7F',
            __typename: 'TransactionAccount',
          },
          {
            displayName: null,
            id: 'd88506cc-bbaf-4cac-8ce0-76fea4c64f10',
            transactionAccountNumber: 'AC-3WMD-4J2X-ZTG6',
            __typename: 'TransactionAccount',
          },
          {
            displayName: 'Atlassian105',
            id: 'd730bdb9-feda-47d8-b79f-3a1632fe7aa5',
            transactionAccountNumber: 'AC-3WRW-KJ3S-WTS8',
            __typename: 'TransactionAccount',
          },
          {
            displayName: 'ITAP-BillTo-1601871485422',
            id: 'd563ddc5-f682-484b-af65-96540a71d5e8',
            transactionAccountNumber: 'AC-3W8X-GC33-2SNX',
            __typename: 'TransactionAccount',
          },
          {
            displayName: 'Atlassian efwef',
            id: 'c92b3145-2dad-41f1-8304-915631a4194a',
            transactionAccountNumber: 'AC-3X6B-7F9Z-ZJDN',
            __typename: 'TransactionAccount',
          },
        ],
        __typename: 'TransactionAccountConnection',
      },
      __typename: 'Person',
    },
  },
};
